import { render, staticRenderFns } from "./InfoWrapper.vue?vue&type=template&id=bc99eb60&scoped=true&lang=pug"
import script from "./InfoWrapper.vue?vue&type=script&lang=js"
export * from "./InfoWrapper.vue?vue&type=script&lang=js"
import style0 from "./InfoWrapper.vue?vue&type=style&index=0&id=bc99eb60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc99eb60",
  null
  
)

export default component.exports